'use client'

import React from 'react'

import {
  QueryClient,
  QueryClientProvider,
  useQueryErrorResetBoundary
} from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { ErrorBoundary } from 'react-error-boundary'
import { ZodError } from 'zod'

import type { FC, PropsWithChildren } from 'react'
import { Error503 } from '../../web-components/components/errors-pages/Error503'
import './react-query-provider.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5000,
      throwOnError: (error, query) => {
        if (error instanceof ZodError) {
          console.error(`ZodError: ${query?.queryHash}`, error.issues)
        }

        return false
      }
    }
  }
})

export const ReactQueryProvider: FC<PropsWithChildren<unknown>> = ({
  children
}) => {
  const { reset } = useQueryErrorResetBoundary()

  return (
    <ErrorBoundary
      onReset={reset}
      onError={(error) => console.log(error)}
      fallbackRender={({ resetErrorBoundary }) => (
        <Error503 onClick={resetErrorBoundary} />
      )}
    >
      <QueryClientProvider client={queryClient}>
        {children}
        <ReactQueryDevtools
          buttonPosition="bottom-left"
          initialIsOpen={false}
        />
      </QueryClientProvider>
    </ErrorBoundary>
  )
}

export default ReactQueryProvider
